import { MenuNode } from './MenuNode';
import { Helper } from './Helper';
import { BaseSensor } from './BaseSensor';
import { pumpModulationToFlowRate } from './PumpModulationToFlowRate';
export class Generator {
	//static backTarget='goto:diagnosecode_ladeschirm';

	static backTarget = 'goto:historyBack';
	public static DiagnoseCodes_0_99() {
		return Generator.DiagnoseCodesFromTo(0, 99);
	}
	public static DiagnoseCodes_100_199() {
		return Generator.DiagnoseCodesFromTo(100, 199);
	}
	public static DiagnoseCodes_200_299() {
		return Generator.DiagnoseCodesFromTo(200, 299);
	}
	public static DiagnoseCodes_300_399() {
		return Generator.DiagnoseCodesFromTo(300, 399);
	}
	public static DiagnoseCodes_500_599() {
		return Generator.DiagnoseCodesFromTo(500, 599);
	}
	public static DiagnoseCodes_600_699() {
		return Generator.DiagnoseCodesFromTo(600, 699);
	}
	public static DiagnoseCodesFromTo(min: number, max: number) {
		console.log("Generator: Generating menues.");
		let ts = MenuNode.getTranslator();

		if (ts === undefined) {
			console.error("Translator-Service not yet defined.");
			return;
		}

		let nodes = new Array<MenuNode>();

		let settableDiagnoseCodes = [
			"007", "043", "097",
			"122", "123", "124", "125", "126", "127", "130", "131", "134", "135", "136", "137", "138", "139", "140", "141", "142", "143", "144", "145", "146", "147", "148", "149", "150", "151", "152", "153", "154", "155", "156", "157", "158", "159", "160", "161", "162", "163",
			"230", "233", "240", "245", "267", "268", , "291",
			"340", "342", "346", "347", "348", "349", "351", "352", "353", "355", "357", "360", "361", "363", "364", "384", "385", "386", "387", "388", "390", "391", "398"];

		let ignoreDiagnoseCodes: string[] = [
			"046", "132", "133", "026", "029", "034", "039", "052", "062",
			"202", "270",
			"343", "345", "358", "350", "373", "393", "394",
			"517", "521", "524", "600", "389", "526"
		];
		ignoreDiagnoseCodes.push('043', '071', '130', '134', '163', '340', '342', '346', '347', '348', '349', '351', '352', '353', '355', '357', '378', '379', '380', '381', '383', '384', '385', '386', '387', '388', '389');
		let estricht = ["134", "135", "136", "137", "138", "139", "140", "141", "142", "143", "144", "145", "146", "147", "148", "149", "150", "151", "152", "153", "154", "155", "156", "157", "158", "159", "160", "161", "162", "163"];
		let sensorConfigs = {
			'leistungsbegrenzung_kompressor': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 25,
				'gran': 1,
				'cur': 0
			},
			'd000': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['60.8']
			},
			'd001': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['0.0', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd002': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['12.5', '0.0', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd003': {
				'unit': 'AICI_UNIT_KELVIN',
				'list': ['0.0', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'aus_d003': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd004': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 100,
				'cur': 55,
				'gran': 1
				//'list':['3.1','4.0','5.0','6.0','7.0','8.0','9.0','10.0','11.0','12.0','13.0','14.0','15.0','16.0','17.0','18.0','19.0','20.4']
			},
			'_d002': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 1,
				'max': 60,
				'gran': 1,
				'cur': 20,
			},
			'd005': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 10,
				'max': 100,
				'gran': 0.1,
				'cur': 50,
			},
			'__d006': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 34,
				'max': 70,
				'gran': 1,
				'cur': 55,
			},
			'd007': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 35,
				'max': 70,
				'gran': 1,
				'cur': 55,
			},
			'__d008': {
				'unit': '',
				'list': ['ENUM_ZONE_VALVE_STATUS_OPEN', 'ENUM_ZONE_VALVE_STATUS_CLOSE']
			},
			'd014': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['1481.6', '12.3', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd015': {
				'unit': '',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 4.2
			},
			'd016': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['22977.2', '32', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd017': {
				'unit': '',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 4.1
			},
			'd018': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['280', '0.0', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd019': {
				'unit': '',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 3.5
			},
			'd022': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['4632.5', '0', '3.1', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20.4']
			},
			'd023': {
				'unit': '',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 3.5
			},
			'__d016': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'__d017': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_017_VALUE_0', 'DELIGHT_DIA_CODE_ID_017_VALUE_1']
			},
			'__d018': {
				'unit': '',
				'list': ['DELIGHT_ZONE_MODE_SELECTION_ENTRY_CONTINUOUS', 'DELIGHT_DIA_CODE_ID_018_VALUE_3']
			},
			'__d024': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'__d025': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'aus_d026': {
				'unit': '',
				'list': ['AICI_OFF_BIG', 'AICI_ON_BIG']
			},
			'd027': {
				'unit': '',
				'list': ['AICI_OFF_BIG', 'AICI_ON_BIG']
			},
			'd028': {
				'unit': '',
				'list': ['AICI_OFF_BIG', 'AICI_ON_BIG']
			},
			'aus_d029': {
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			},
			'd033': {
				'unit': 'AICI_UNIT_DEGREEMINUTE',
				'list': ['-166']
			},
			'___d033': {
				'unit': 'AICI_UNIT_ROTATIONSPERMINUTE',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 0
			},
			'aus_d034': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 22
			},
			'd035': {
				'unit': '',
				'list': ['DELIGHT_DIA_CODE_ID_035_VALUE_0', 'DELIGHT_DIA_CODE_ID_035_VALUE_100', 'DELIGHT_DIA_CODE_ID_035_VALUE_40']
			},
			'd036': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 1000,
				'gran': 1,
				'cur': 11
			},
			'd037': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 43.6
			},
			'd038': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 70,
				'gran': 0.1,
				'cur': 23.2
			},
			'd039': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 70,
				'gran': 1,
				'cur': 50
			},
			'd040': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 70,
				'gran': 0.1,
				'cur': 49.9
			},
			'd041': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 70,
				'gran': 0.1,
				'cur': 43.5
			},
			'd043': {
				'unit': '',
				'min': 0.1,
				'max': 4,
				'gran': 0.1,
				'cur': 0.6
			},
			'd044': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1100,
				'gran': 0.5,
				'cur': 1
			},
			'd045': {
				'unit': '',
				'min': -5,
				'max': 10,
				'gran': 0.5,
				'cur': 1
			},
			'd046': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1100,
				'gran': 0.5,
				'cur': 1.2
			},
			'd048': {
				'unit': '',
				'min': -5,
				'max': 10,
				'gran': 0.5,
				'cur': 1
			},
			'd049': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1100,
				'gran': 0.1,
				'cur': 0
			},
			'd050': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 1100,
				'gran': 0.5,
				'cur': 3.4
			},
			'd052': {
				'unit': '',
				'min': 10,
				'max': 188,
				'gran': 1,
				'cur': 130
			},
			'd060': {
				'unit': 'AICI_UNIT_LITERPERHOUR',
				'min': 0,
				'max': 2200,
				'gran': 1,
				'cur': 589
			},
			'd061': {
				'unit': 'AICI_UNIT_BAR',
				'min': 0,
				'max': 70,
				'gran': 0.1,
				'cur': 1.5
			},
			'd062': {
				'unit': 'AICI_UNIT_BAR',
				'min': 0,
				'max': 70,
				'gran': 1,
				'cur': 1.2
			},
			'd064': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 1200,
				'gran': 1,
				'cur': 73
			},
			'd066': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 1200,
				'gran': 1,
				'cur': 0
			},
			'd067': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 60,
				'gran': 1,
				'cur': 0
			},
			'd071': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 15,
				'max': 90,
				'gran': 1,
				'cur': 50
			},
			'd072': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 1100,
				'gran': 1,
				'cur': 10
			},
			'd073': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1500,
				'gran': 73,
				'cur': 41
			},
			'd074': {
				'unit': '',
				'min': 0,
				'max': 1500,
				'gran': 1,
				'cur': 9
			},
			'd076': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1100,
				'gran': 0.5,
				'cur': 0.0
			},
			'd077': {
				'unit': 'AICI_UNIT_KWH',
				'min': 0,
				'max': 1500,
				'gran': 1,
				'cur': 8
			},
			'd080': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 12
			},
			'd081': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 999,
				'gran': 1,
				'cur': 0
			},
			'd091': {
				'unit': 'AICI_UNIT_KWH',
				'list': ['DELIGHT_HP_DIA_CODE_ID_091_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_091_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_091_VALUE_2'],
			},
			'd092': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 30,
				'gran': 0.1,
				'cur': 23.8
			},
			'd095': {
				'list': ['{{tr:DELIGHT_SOFTWARE_VERSION_AI}} 0406.01.08', '{{tr:DELIGHT_SOFTWARE_VERSION_HMU_INDOOR}} 405.01.02', '{{tr:DELIGHT_SOFTWARE_VERSION_HMU_OUTDOOR}} 0422.01.28'],
				'unit': ''
			},
			'd096': {
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL'],
				'unit': ''
			},
			'd097': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 5,
				'max': 30,
				'gran': 0.5,
				'cur': 21
			},
			'd122': {
				'unit': 'AICI_UNIT_PERCENT',
				'gran': 1,
				'min': 29,
				'max': 100,
				'cur': 29
			},
			'd123': {
				'unit': 'AICI_UNIT_PERCENT',
				'gran': 1,
				'min': 29,
				'max': 100,
				'cur': 29
			},
			'd124': {
				'unit': 'AICI_UNIT_PERCENT',
				'gran': 1,
				'min': 29,
				'max': 100,
				'cur': 29
			},
			'd125': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 120,
				'gran': 1,
				'cur': 0
			},
			'd126': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 5.5,
				'gran': 0.5,
				'cur': 5.5
			},
			'd127__2': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_127_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_127_VALUE_2', 'DELIGHT_HP_DIA_CODE_ID_127_VALUE_3', 'DELIGHT_HP_DIA_CODE_ID_127_VALUE_4', 'DELIGHT_HP_DIA_CODE_ID_127_VALUE_0']
			},
			'd127': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_127_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_127_VALUE_1']
			},
			'd130': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_130_VALUE_3', 'DELIGHT_HP_DIA_CODE_ID_130_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_130_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_130_VALUE_2']
			},
			'd131': {
				'unit': 'AICI_UNIT_AMPERE',
				'min': 13,
				'max': 16,
				'cur': 16,
				'gran': 1
			},
			'd132': {
				'unit': 'AICI_UNIT_BAR',
				'min': 0,
				'max': 200,
				'gran': 1,
				'cur': 131
			},
			'd133': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_133_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_133_VALUE_1']
			},
			'd134': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 24
			},
			'd135': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 30
			},
			'd136': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 35
			},
			'd137': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 40
			},
			'd138': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd139': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd140': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd141': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd142': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd143': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd144': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd145': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd146': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 40
			},
			'd147': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 35
			},
			'd148': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 30
			},
			'd149': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 25
			},
			'd150': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd151': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd152': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd153': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd154': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd155': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd156': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 10
			},
			'd157': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 30
			},
			'd158': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 35
			},
			'd159': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 40
			},
			'd160': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 45
			},
			'd161': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 35
			},
			'd162': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 25
			},
			'd163': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 25,
				'max': 45,
				'gran': 1,
				'cur': 0
			},
			'd200': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 5000,
				'gran': 1,
				'cur': 10
			},
			'd201': {
				'unit': '',
				'min': 0,
				'max': 5000,
				'gran': 1,
				'cur': 31
			},
			'd202': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 5000,
				'gran': 1,
				'cur': 18
			},
			'd230': {
				'unit': 'AICI_UNIT_DEGREEMINUTE',
				'min': -120,
				'max': -30,
				'gran': 5,
				'cur': -60
			},
			'd231': {
				'unit': 'AICI_UNIT_MBAR',
				'min': 200,
				'max': 900,
				'gran': 10,
				'cur': 900
			},
			'd233': {
				'unit': 'AICI_UNIT_DEGREEMINUTE',
				'min': 30,
				'max': 120,
				'gran': 5,
				'cur': 60
			},
			'd240': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 40,
				'max': 60,
				'gran': 1,
				'cur': 40
			},
			'd245': {
				'unit': 'AICI_UNIT_HOUR',
				'min': 0,
				'max': 9,
				'gran': 1,
				'cur': 5
			},
			'd248': {
				'unit': '',
				'min': 0,
				'max': 500,
				'gran': 1,
				'cur': 49
			},
			'd267': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 3,
				'max': 15,
				'gran': 1,
				'cur': 7
			},
			'd268': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_268_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_268_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_268_VALUE_2']
			},
			'd269': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_269_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_269_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_269_VALUE_2']
			},
			'd270': {
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			},
			'd291': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd340': {
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			},
			'd342': {
				'unit': '',
				'min': 0,
				'max': 29,
				'gran': 1,
				'cur': 0
			},
			'd346': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 10,
				'max': 99,
				'gran': 1,
				'cur': 21
			},
			'd347': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': -30,
				'max': 20,
				'gran': 1,
				'cur': 0
			},
			'd348': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': -20,
				'max': 50,
				'gran': 1,
				'cur': -7
			},
			'd349': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': -21,
				'max': 40,
				'gran': 1,
				'cur': -21
			},
			'd351': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 15,
				'max': 90,
				'gran': 1,
				'cur': 15
			},
			'd352': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd353': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd355': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_355_VALUE_3', 'DELIGHT_HP_DIA_CODE_ID_355_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_355_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_355_VALUE_2']
			},
			'd357': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 3,
				'max': 20,
				'gran': 0.5,
				'cur': 5
			},
			'd358': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_358_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_358_VALUE_1']
			},
			'd360': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd361': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd362': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 60,
				'gran': 1,
				'cur': 0
			},
			'd363': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 3,
				'max': 15,
				'gran': 1,
				'cur': 5
			},
			'd364': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd367': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 100
			},
			'd368': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 0
			},
			'd369': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 49.6
			},
			'd370': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 50
			},
			'd371': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 100,
				'gran': 0.1,
				'cur': 5.2
			},
			'd372': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 1,
				'cur': 33.3
			},
			'd373': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 1,
				'cur': 50
			},
			'd374': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 6.3
			},
			'd375': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 6.1
			},
			'd376': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 2.0
			},
			'd377': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 2.0
			},
			'd378': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 19.8
			},
			'd379': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 99,
				'gran': 0.1,
				'cur': 36.7
			},
			'd380': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_380_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_380_VALUE_0']
			},
			'd381': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_381_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_381_VALUE_0']
			},
			'd382': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 1,
				'cur': 29
			},
			'd383': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 100,
				'gran': 1,
				'cur': 0
			},
			'd384': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 20,
				'max': 80,
				'gran': 1,
				'cur': 25
			},
			'd385': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_385_VALUE_2', 'DELIGHT_HP_DIA_CODE_ID_385_VALUE_3', 'DELIGHT_HP_DIA_CODE_ID_385_VALUE_4', 'DELIGHT_HP_DIA_CODE_ID_385_VALUE_5', 'DELIGHT_HP_DIA_CODE_ID_385_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_385_VALUE_1']
			},
			'd386': {
				'unit': 'AICI_UNIT_KELVIN',
				'min': -3,
				'max': 3,
				'gran': 0.5,
				'cur': 0
			},
			'd387': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 120,
				'gran': 5,
				'cur': 60
			},
			'd388': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 120,
				'gran': 5,
				'cur': 60
			},
			'd390': {
				'unit': '',
				'list': ['AICI_NO_NORMAL', 'AICI_YES_NORMAL']
			},
			'd391': {
				'unit': '',
				'list': ['01.01.2019']
			},
			'd392': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_392_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_392_VALUE_1']
			},
			'd395': {
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			},
			'd396': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 120,
				'cur': 0,
				'gran': 1
			},
			'd397': {
				'unit': 'AICI_UNIT_KW',
				'min': 0,
				'max': 120,
				'cur': 0,
				'gran': 1
			},
			'd398': {
				'unit': 'AICI_UNIT_MINUTE',
				'min': 0,
				'max': 120,
				'cur': 10,
				'gran': 1
			},
			'd500': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd501': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_501_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_501_VALUE_0']
			},
			'd502': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 120,
				'gran': 0.1,
				'cur': 7.4
			},
			'd503': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 120,
				'gran': 1,
				'cur': 44
			},
			'd504': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 120,
				'gran': 0.1,
				'cur': 7.3
			},
			'd505': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 120,
				'gran': 0.1,
				'cur': 70
			},
			'd506': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd507': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd508': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd509': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_509_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_509_VALUE_0']
			},
			'd510': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_510_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_510_VALUE_0']
			},
			'd511': {
				'unit': 'AICI_UNIT_BAR',
				'min': 0,
				'max': 120,
				'gran': 0.1,
				'cur': 31
			},
			'd515': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': -100,
				'max': 120,
				'gran': 0.1,
				'cur': -0.1
			},
			'd516': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd517': {
				'unit': 'AICI_UNIT_PERCENT',
				'min': 0,
				'max': 120,
				'gran': 1,
				'cur': 25
			},
			'd518': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_518_VALUE_0', 'DELIGHT_HP_DIA_CODE_ID_518_VALUE_1']
			},
			'd521': {
				'unit': '',
				'list': ['AICI_ON_NORMAL', 'AICI_OFF_NORMAL']
			},
			'd522': {
				'unit': 'AICI_UNIT_BAR',
				'min': 0,
				'max': 120,
				'gran': 0.1,
				'cur': 9.6
			},
			'd523': {
				'unit': 'AICI_UNIT_CELSIUS',
				'min': 0,
				'max': 120,
				'gran': 1,
				'cur': 67
			},
			'd524': {
				'unit': '',
				'list': ['1']
			},
			'd525': {
				'unit': '',
				'list': ['AICI_OFF_NORMAL', 'AICI_ON_NORMAL']
			},
			'd527': {
				'unit': '',
				'list': ['DELIGHT_HP_DIA_CODE_ID_527_VALUE_1', 'DELIGHT_HP_DIA_CODE_ID_527_VALUE_2', 'DELIGHT_HP_DIA_CODE_ID_527_VALUE_3', 'DELIGHT_HP_DIA_CODE_ID_527_VALUE_0']
			},
			'd9999': {
				'tag': 'Einstellbare Heizbelastung',
				'unit': 'AICI_UNIT_KWH',
				'list': ['3.0', '4.0', '5.0', '6.0', '7.0', '8.0', '9.0', '10.0', '11.0', '12.0', '13.0', '14.0', '15.0', '16.0', '17.0', '18.0', '19.0', '20', '21', '22', '23', '24']
			},
			'd9998': {
				'tag': 'Restförderhöhe',
				'unit': 'AICI_UNIT_MBAR',
				'min': 100,
				'max': 400,
				'gran': 10,
				'cur': 200
			},
			'd9997': {
				'tag': 'ist das die korrekte gasart?',
				'unit': '',
				'list': ['AICI_YES_NORMAL', 'AICI_NO_NORMAL']
			}
		};

		let configService = MenuNode.getDataIoService().getConfiguration();
		if (configService.getConfigPrefix() == 'de') {
			ignoreDiagnoseCodes.push('162');
		}

		let sc = MenuNode.getDataIoService().getConfiguration().simulatorConfig;
		/*if(sc.getVariant() == 'ecoTEC plus'){
			sensorConfigs.d170.list.shift();
			sensorConfigs.d170.list.shift();
		}*/

		let di = MenuNode.getDataIoService().getDeviceInfo();
		for (let name of Object.keys(sensorConfigs)) {
			let s: BaseSensor = null;
			let data = sensorConfigs[name];
			if (data['list']) {
				s = new BaseSensor();
				s.setList(data['list']);
				s.setUnit(data['unit']);
				s.setCurrentValue(0);
			} else {
				s = BaseSensor.fromArgs(name, data['cur'], data['min'], data['max'], data['gran'], data['unit']);
			}
			if (name == 'd084') {
				s.setSpecialValue(-100, "DELIGHT_DIA_REPLACE_TEXT_NOT_SET");
			}
			if (name == '__d006') {
				s.setSpecialValue(34, "AICI_OFF_NORMAL", "iconDomesticHotWaterDis")
			}
			if (name == 'd349') {
				s.setSpecialValue(-21, "AICI_OFF_NORMAL")
			}
			if (['d122', 'd123', 'd124'].includes(name)) {
				s.setSpecialValue(29, "DELIGHT_DIA_REPLACE_TEXT_AUTO")
			}
			if (name == 'd126') {
				s.setSpecialValue(0, 'DELIGHT_HP_DIA_CODE_ID_126_VALUE_0')
				s.setSpecialValueTemplateParameters(0, ['smallValue']);
			}
			if (name == 'd367') {
				s.registerHook('valueChanged', (newValue) => { di.getScale('d060').setCurrentValue(parseInt("" + pumpModulationToFlowRate(newValue))); });;
				s.setCurrentValue(54.1);
			}
			if (name == 'd127__2') {
				s.registerHook('valueChanged', (newValue) => { di.getScale('d060').setCurrentValue(newValue); });;
			}
			if (name == 'd020') {
				s.registerHook('valueChanged',
					(newVal) => {
						let d006 = di.getScale('d006');
						if (d006.getCurrentValue() > newVal) {
							d006.setCurrentValue(newVal);
						}
						d006.setMaxValue(newVal);
					});
			}
			if (name == 'd094') {
				s.registerHook('valueChanged',
					function (newVal) {
						if (newVal == 1) {
							s.setCurrentValue(0);
						}
					}
				);
			}
			if (name == 'leistungsbegrenzung_kompressor') {
				s.setSpecialValue(0, "AICI_OFF_NORMAL")
			}
			s.setName(name);
			di.setScale(name, s);
		}


		for (let i = min; i < max; i++) {

			let id = Helper.threeDigits(i);
			let editable: boolean = settableDiagnoseCodes.includes(id);
			if (ignoreDiagnoseCodes.includes(id)) {
				continue;
			}
			let key: string = "DELIGHT_HP_DIA_CODE_ID_" + id;
			if (!ts.has(key) && !['046', '202', '524'].includes(id)) {
				//console.log("diag code not found: "+id);
				continue;
			}
			//console.log("diag code "+id);
			switch (i) {
				case 161: {

					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:servicedate}}",
						"type": "menuentry",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"children": [
							{
								"name": "timeset_date_diag",
								"title": "DELIGHT_SERVICE_DATE_TITLE",
								"text": [
									"EDITOR_SERVICE_DATE_SUBLINE_1"
								],
								"template": "timeset",
								"buttons": "confirm,back,slider,menu",
								"template_parameter": "date,lightTitle,showText,lightText",
								"onConfirm": "set:servicedate",
								"value": "{{get:servicedate.toInt}}",
								"target": "goto:diagnosecode_ladeschirm",
								"back": Generator.backTarget
							}
						]
					};
					nodes.push(new MenuNode(d));
					continue;
				}
				case 46:
				case 202:
				case 524: {

					let title = 'D.' + Helper.threeDigits(i) + "\n{{tr:DELIGHT_DIA_CODE_UNKNOWN}}|{{get:deviceinfo.d" + id + ".toString}}";
					let nodeData = {
						'title': title,
						'type': 'menuentry',
						"id": "diagnoseCode." + id,
						'target': 'goto:child:0'
					}
					let editable: boolean = settableDiagnoseCodes.includes(id);

					let node = new MenuNode(nodeData);
					let childData = {
						'title': 'D.' + Helper.threeDigits(i),
						'template': (editable ? 'settingsvalue' : 'showvalue'),
						'text': 'DELIGHT_DIA_CODE_UNKNOWN',
						'type': 'temperature',
						'template_parameter': (editable ? 'circular,smallValue' : 'smallValue'),
						'buttons': (editable ? 'back,up,down,confirm' : 'back'),
						'onConfirm': 'set:deviceinfo.d' + id,
						'target': 'goto:diagnosecode_ladeschirm',
						'back': Generator.backTarget
					}
					node.addChild(new MenuNode(childData));
					nodes.push(node);
					continue;
				}
				case 391: {
					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:servicedate}}",
						"type": "menuentry",
						"back": "goto:previous",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"template_parameter": "nobox,darkerTitle,loadDelay,inline",
						"buttons": "confirm,slider,back",
						"children": [
							{
								"name": "timeset_date",
								"back": "goto:fachhandwerker-ladebalken",
								"title": "DELIGHT_SERVICE_DATE_TITLE",
								"text": [
									"DELIGHT_INSTALLER_MENU_ENTRY_SERVICE_DATE_TEXT"
								],
								"template": "timeset",
								"buttons": "confirm,back,slider,menu",
								"template_parameter": "date,lightTitle,showText,lightText",
								"onConfirm": "set:servicedate",
								"value": "{{get:servicedate.toInt}}",
								"target": "goto:diagnoseCodes300-399"
							}
						]
					};

					nodes.push(new MenuNode(d));
					continue;
				}
				case 95: {
					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|--",
						"type": "menuentry",
						"back": "goto:previous",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"template_parameter": "nobox,darkerTitle,loadDelay,inline",
						"buttons": "confirm,slider,back",
						"children": [{
							"title": "DELIGHT_MAIN_MENU_SOFTWARE_VERSION_TITLE",
							"buttons": "back,menu",
							"id": "software_version",
							"template": "list",
							"listDictionary": [
								{
									"key": "DELIGHT_SOFTWARE_VERSION_HMU_INDOOR",
									"value": "0405.02.94"
								},
								{
									"key": "DELIGHT_SOFTWARE_VERSION_AI",
									"value": "0406.03.02"
								},
								{
									"key": "DELIGHT_SOFTWARE_VERSION_HMU_OUTDOOR",
									"value": "0405.02.94"
								}
							]
						}
						]
					};

					nodes.push(new MenuNode(d));
					continue;

				}
				case 96: {
					let d = {
						"title": 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|--",
						"type": "menuentry",
						"back": "goto:previous",
						"id": "diagnoseCode." + id,
						"target": "goto:child:0",
						"template_parameter": "nobox,darkerTitle,loadDelay,inline",
						"buttons": "confirm,slider,back",
						"children": [
							{
								"template": "menu",
								"title": "D.096",
								"subtitle": key,
								"buttons": "confirm,slider,back",
								"template_parameter": "nobox,darkerTitle,loadDelay,inline,subtitleAtBottom,circular,smallValue",
								"children": [
									{
										"type": "menuentry",
										"title": "AICI_NO_NORMAL",
										"target": "goto:diagnosecode_ladeschirm"
									},
									{
										"type": "menuentry",
										"title": "AICI_YES_NORMAL",
										"target": "goto:child:0",
										"children": [
											{
												"name": "WERKSEINSTELLUNGEN",
												"infoId": "24",
												"id": "factory_settings_diag",
												"title": "DELIGHT_HP_DIA_CODE_ID_096",
												"buttons": "confirm,back,menu",
												"template": "toast",
												"icon": "iconWarning",
												"onConfirm": "run:reset",
												"target": "goto:reset_running",
												"text": [
													"DELIGHT_RESET_FACTORY_SETTING_CONFIRM_LINE_1",
													"DELIGHT_RESET_FACTORY_SETTING_CONFIRM_LINE_2",
													"DELIGHT_NO_BACK_YES_OK_LINE"
												]
											}
										]
									}
								]
							}

						]
					};
					nodes.push(new MenuNode(d));
					continue;
				}
				default: {

				}
			}

			let backTarget = '0-99';
			for (let j = 0; j < 6; j++) {
				if (i >= j * 100 && i < (j + 1) * 100) {
					backTarget = `${j}00-${j}99`;
				}
			}
			let title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{get:deviceinfo.d" + id + ".toString}}";
			if ([291, 360, 364].includes(i)) {
				title = 'D.' + Helper.threeDigits(i) + "\n{{tr:" + key + "}}|{{tr:AICI_NO_NORMAL}}";
			}
			let nodeData = {
				'title': title,
				'type': 'menuentry',
				"id": "diagnoseCode." + id,

			}
			if (editable) {
				nodeData['target'] = 'goto:child:0';
			}


			let node = new MenuNode(nodeData);
			let childData = {
				'title': 'D.' + Helper.threeDigits(i),
				'template': (editable ? 'settingsvalue' : 'showvalue'),
				'text': [key],
				'type': 'temperature',
				'template_parameter': (editable ? 'circular,smallValue' : 'smallValue'),
				'buttons': (editable ? 'back,up,down,confirm' : 'back'),
				'onConfirm': 'set:deviceinfo.d' + id,
				'target': `goto:diagnoseCodes${backTarget}`,
				'back': Generator.backTarget
			}
			if (i == 95) {
				childData['template_parameter'] += ',autoScroll';
			}
			//console.log("adding dCode " + title + " / " + nodeData.id);
			if (editable) {
				node.addChild(new MenuNode(childData));
			}
			nodes.push(node);
		}

		return nodes;
	}












	public static DataOverview() {
		let ts = MenuNode.getTranslator();
		if (ts === undefined) {
			console.error("Translator-Service not yet defined.");
			return;
		}
		let elements: Array<any> = new Array<any>();
		let nodes = new Array<MenuNode>();
		let status = '00';
		let statusCode = Helper.threeDigits(status);
		let translationUnits = [];

		let end = false;
		for (let i = 1; i < 256 && !end; i++) {
			let trId = '??DELIGHT_STATUS_ID_' + statusCode + '_DETAILS_' + i;
			if (ts.has(trId)) {
				translationUnits.push(trId);
			} else {
				end = true;
			}
		}
		let key = "S." + status;
		let value = "";

		for (let trId of translationUnits) {
			value += ts.tr(trId);
			if (trId != translationUnits[translationUnits.length - 1]) {
				value += "\n"
			}
		}

		elements.push({ str: 'S.104\n{{tr:DELIGHT_STATUS_ID_104_DETAILS_2}}|{{tr:DELIGHT_STATUS_ID_104_DETAILS_1}}', id: 'dataOverview.104' });
		elements.push({ str: 'S.100|{{tr:DELIGHT_STATUS_ID_100_DETAILS_1}}', id: 'dataOverview.100' });

		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_BLOCKING_TIME}}|{{get:deviceinfo.d067.toString}}', id: 'dataOverview.067' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_IMMERSION_HEATER_BLOCKING_TIME}}|{{get:deviceinfo.d362.toString}}', id: 'dataOverview.362' })
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_ENERGY_INTEGRAL}}|{{get:deviceinfo.d033.toString}}', id: 'dataOverview.033' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_MODULATION}}|{{get:deviceinfo.d037.toString}}', id: 'dataOverview.037' });
		elements.push({ str: '{{tr:DELIGHT_HP_DIA_CODE_ID_005}}|{{get:deviceinfo.d005.toString}}', id: 'dataOverview.005' });
		elements.push({ str: '{{tr:DELIGHT_HP_DIA_CODE_ID_040}}|{{get:deviceinfo.d040.toString}}', id: 'dataOverview.040' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_RETURN_TEMP}}|{{get:deviceinfo.d041.toString}}', id: 'dataOverview.041' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_BUILD_CIRC_PUMP_MODULATION}}|{{get:deviceinfo.d367.toString}}', id: 'dataOverview.367' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_BUILD_CIRC_FLOW_RATE}}|{{get:deviceinfo.d060.toString}}', id: 'dataOverview.060' });

		elements.push({ str: '{{tr:DELIGHT_HP_DIA_CODE_ID_007}}|{{get:deviceinfo.d007.toString}}', id: 'dataOverview.007' }); //DELIGHT_HP_DIA_CODE_ID_007
		elements.push({ str: '{{tr:DELIGHT_HP_DIA_CODE_ID_004}}|{{get:deviceinfo.d004.toString}}', id: 'dataOverview.004' }); //DELIGHT_HP_DIA_CODE_ID_004
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_IMMERSION_HEATER_PWR_OUTPUT}}|0.0 {{tr:AICI_UNIT_KW}}', id: 'dataOverview.xxx' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_IMMERSION_HEATER_TARGET_FLOW_TEMP}}|{{get:deviceinfo.d368.toString}}', id: 'dataOverview.368' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_IMMERSION_HEATER_FLOW_TEMP}}|{{get:deviceinfo.d369.toString}}', id: 'dataOverview.369' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_CONDENSATION_TEMP}}|{{get:deviceinfo.d370.toString}}', id: 'dataOverview.370' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_EVAPORATION_TEMP}}|{{get:deviceinfo.d371.toString}}', id: 'dataOverview.371' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_ACTUAL_SUPERHEATING}}|{{get:deviceinfo.d377.toString}}', id: 'dataOverview.377' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_SUPERHEATING_TARGET}}|{{get:deviceinfo.d377.toString}}', id: 'dataOverview.377_2' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_ACTUAL_SUBCOOLING}}|{{get:deviceinfo.d375.toString}}', id: 'dataOverview.375' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_SUBCOOLING_TARGET}}|{{get:deviceinfo.d374.toString}}', id: 'dataOverview.374' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_INLET_TEMP_TT390}}|{{get:deviceinfo.d504.toString}}', id: 'dataOverview.504' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_COMPRESSOR_OUTLET_TEMP_TT100}}|{{get:deviceinfo.d505.toString}}', id: 'dataOverview.505' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_FAN_MODULATION}}|{{get:deviceinfo.d372.toString}}', id: 'dataOverview.372' });
		elements.push({ str: '{{tr:DELIGHT_HP_DATAOVERVIEW_AIR_INLET_TEMP}}|{{get:deviceinfo.d038.toString}}', id: 'dataOverview.038' });
		//stellung 3-wege
		//elements.push('{{tr:DELIGHT_HP_DIA_CODE_ID_527}}|{{get:deviceinfo.d527.toString}}');
		for (let element of elements) {
			let d = {
				"title": element.str,
				"type": "menuentry",
				"id": element.id
			};
			if (d.title.indexOf('DELIGHT_DATAOVERVIEW_PRESSURE_HEAD') != '-1') {
				d['id'] = "dataOverView.DELIGHT_DATAOVERVIEW_PRESSURE_HEAD";
			}
			nodes.push(new MenuNode(d));
		}
		return nodes;
	}

}